module.exports = __webpack_public_path__ + "static/media/curveImage.792f6c30.svg";